import { Box } from '@material-ui/core';
import { getUsersByUserId, patchUnblockUser, User } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface UnblockUserMessageProps {
  userId: string;
  selectedUser: User;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}

export const UnblockUserMessage = ({
  userId,
  selectedUser,
  opened,
  setOpened,
  handleClose,
}: UnblockUserMessageProps) => {
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const { request, loading } = useRequest();

  const onUnblockUser = async () => {
    await request(patchUnblockUser, { userId: selectedUser.id });
    handleClose();
    revalidate();
  };

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={handleClose}>
            <Text tId="CANCEL" />
          </StandardButton>
          <StandardButton main loading={loading} onClick={() => onUnblockUser()}>
            <Text tId={'UNBLOCK_USER'} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant="h3" color="textPrimary">
          <Text tId={'UNBLOCK_USER'} />
        </Font>
      </Box>
      <Box pt={3}>
        <Font variant={'body1'} color={'textSecondary'}>
          <Text tId={'DO_YOU_WANT_TO_UNBLOCK_THE_USER'} dynamicDataTexts={[selectedUser.username]} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
